import OktaAuth from '@okta/okta-auth-js';
import { SSO_OKTA_CLIENT_ID, SSO_OKTA_ISSUER } from 'common/auth/sso/okta.config';

const oktaAuth = new OktaAuth({
    issuer: SSO_OKTA_ISSUER,
    clientId: SSO_OKTA_CLIENT_ID,
    redirectUri: `${document.location.protocol}//${document.location.host}/sso/okta`,
    postLogoutRedirectUri: `${document.location.protocol}//${document.location.host}/sso/okta/logout`,
    transformAuthState: async (oktaAuth, authState) => {
        if (authState?.isAuthenticated) {
            const user = await oktaAuth.token?.getUserInfo();
            authState.isAuthenticated = !!user;
        }

        return authState;
    },
    tokenManager: { storageKey: 'lx-orion-token', storage: 'localStorage', autoRenew: true },
    storageManager: {
        token: { storageTypes: ['memory'] },
        cache: { storageTypes: ['memory'] },
        transaction: { storageTypes: ['memory'] },
    },
    services: {
        autoRenew: true,
        autoRemove: false,
    },
});

export default oktaAuth;
